export const CONTAINER_STYLE = (opacity) => {
    if (opacity == 60)
        return "bg-slate-50 opacity-60 w-screen h-screen fixed z-[9999] top-0  left-0 flex justify-center items-center ";

    return "bg-slate-50 w-screen h-screen fixed z-[9999] top-0  left-0 flex justify-center items-center ";
};

export const LOGO_STYLE = "w-auto h-auto z-40";
